import "@fortawesome/fontawesome-svg-core/styles.css";
import AppRoutes from "./routes";
import "./styles/colors.css";
import "./styles/drawer.scss";
import "./styles/fa.css";
import "./styles/globals.scss";
import "./styles/help.scss";

import { useEffect, useState } from "react";
import smoothscroll from "smoothscroll-polyfill";
import { EnvironmentsAPI } from "./providers/EnvironmentsAPI";
import { Loading } from "./shared/components/Loading";
import WorkingTime from "./shared/plugins/core/schema/configurations/WorkingTime";
import { EnvironmentStorage } from "./shared/tools/EnvironmentStorage";
import { ThemeLoader } from "./shared/tools/ThemeLoader";
import { UserStorage } from "./shared/tools/UserStorage";
import { useBroadcastChannel } from "shared/hooks/useBroadcastChannel";

smoothscroll.polyfill();

function App() {
  const [loading, setLoading] = useState(true);

  const loginBroadcast = useBroadcastChannel("login", (message) => {
    window.location.reload();
  })

  useEffect(() => {
    const onUpdatedTheme = () => {
      const r = document.querySelector(":root");
      r.style.setProperty("--primary-color", "#6161FF");
      r.style.setProperty("--secondary-color", "#6161FF");
    };

    ThemeLoader.onThemeChanged(onUpdatedTheme);
    ThemeLoader.init();

    // const html = document.querySelector("html");
    // const styles = window.getComputedStyle(html);
    // const primaryColor = styles.getPropertyValue("--primary-color");
    // const secondaryColor = styles.getPropertyValue("--secondary-color");
    // window.primaryColor = primaryColor;
    // window.secondaryColor = secondaryColor;

    const getWorkingTime = async (environmentId) => {
      const response = await EnvironmentsAPI.getConfigurationsWorkingTime(
        environmentId
      );
      const { days } = response.getData({ days: [] });

      let workingTime = { days };
      if (days.length > 0) {
        [workingTime] = new WorkingTime([{ days }]).periods;
      }

      return workingTime;
    };

    const loadConfigurations = async () => {
      const currentEnvironment = await EnvironmentStorage.getEnvironment();

      if (UserStorage.isLogged()) {
        try {
          await UserStorage.loadPermissions();
        } catch (err) {
          console.log("Falha no carregamento", err);
        }
      }

      if (currentEnvironment && currentEnvironment.alias) {
        const workingTime = await getWorkingTime(currentEnvironment.id);

        const environmentResponse = await EnvironmentsAPI.getById(
          currentEnvironment.id
        );
        const updatedEnvironment = environmentResponse.getData({});

        EnvironmentStorage.setEnvironment({
          ...currentEnvironment,
          active: updatedEnvironment.active,
        });

        const configurations = await EnvironmentsAPI.getS3Configurations(
          currentEnvironment.alias
        );

        EnvironmentStorage.setConfigurations({
          ...configurations,
          working_time: { ...workingTime },
          extra_menus: await EnvironmentStorage.getEnvironmentExtraMenus(),
        });
        window.dispatchEvent(new CustomEvent("configurationUpdate"));
      }

      setLoading(false);
    };

    loadConfigurations();

    return () => {
      ThemeLoader.removeOnThemeChanged(onUpdatedTheme);
    };
  });

  if (loading) {
    return <Loading fullScreen={true} fullContent={true} />;
  }

  return <AppRoutes />;
}

export default App;
